export enum RoutingFilterErrorCode {
  DOMAIN_CONFLICT = 'EDGE_POOL_ROUTING_RULE_DOMAIN_CONFLICT',
  DOMAIN_ALREADY_BLOCKED = 'EDGE_POOL_ROUTING_RULE_DOMAIN_ALREADY_BLOCKED',
  NOT_FOUND = 'EDGE_POOL_ROUTING_RULE_NOT_FOUND',
  INVALID_POOL_ID = 'EDGE_POOL_ROUTING_RULE_VALIDATION_INVALID_POOL_ID',
  INVALID_DOMAIN = 'EDGE_POOL_ROUTING_RULE_VALIDATION_INVALID_DOMAIN',
  PROJECTS_NOT_FOUND = 'EDGE_POOL_ROUTING_RULE_VALIDATION_PROJECTS_NOT_FOUND',
  PROJECT_CONFLICT = 'EDGE_POOL_ROUTING_RULE_PROJECT_CONFLICT',
  PERMISSION_DENIED = 'EDGE_POOL_ROUTING_RULE_PERMISSION_DENIED',
  UPDATE_ERROR = 'EDGE_POOL_ROUTING_RULE_UPDATE_ERROR',
  UNKNOWN_ERROR = 'EDGE_POOL_ROUTING_RULE_ADMIN_UNKNOWN_ERROR',
  DOMAIN_ONLY_ROUTING_RULE_ALREADY_EXISTS = 'EDGE_POOL_ROUTING_RULE_DOMAIN_ONLY_ROUTING_RULE_ALREADY_EXISTS',
  DOMAIN_TO_BE_BLOCKED_HAS_EXISTING_RULES = 'EDGE_POOL_ROUTING_RULE_DOMAIN_TO_BE_BLOCKED_HAS_EXISTING_RULES',
}

const CONFLICT_CODES: ReadonlySet<string> = new Set([
  RoutingFilterErrorCode.DOMAIN_CONFLICT,
  RoutingFilterErrorCode.PROJECT_CONFLICT,
  RoutingFilterErrorCode.DOMAIN_ALREADY_BLOCKED,
  RoutingFilterErrorCode.DOMAIN_ONLY_ROUTING_RULE_ALREADY_EXISTS,
  RoutingFilterErrorCode.DOMAIN_TO_BE_BLOCKED_HAS_EXISTING_RULES,
]);

export function isConflictError(errorCode?: string): boolean {
  return !!errorCode && CONFLICT_CODES.has(errorCode);
}
